import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
}));

export default function VideoAudition(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const [link, setLink] = useState(props.props ? props.props.link : "");
  const handleNext = props.props ? props.props.function: "";

  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const {link} = event.target.elements;
      try {
       
        var user = firebase.auth().currentUser;
        const dateObj = new Date();
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const date = dateObj.toLocaleDateString(undefined, options)
        const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        db.collection("users").doc(user.email).update({
          VideoAudition: {
            link: link.value,
            completed: true
          },
          LastUpdated: (date + " " + time)
        });

        console.log(link.value);
        handleNext()
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

   const onChangeFunction = (component, value) => {
        setLink(value);
    };

   const populateValues = () => {
        console.log("in here")
        const fs = firebase.firestore()
        var user = firebase.auth().currentUser;
        fs.collection("users").doc(user.email).get()
        .then((snapshot) => {
            if (snapshot.exists) { 
            const dat  = snapshot.data()
            setLink(dat.VideoAudition.link ? dat.VideoAudition.link : "")
            } else {
            console.log("No data available");
            }
        }).catch((error) => {
            console.log("error")
        })
   }

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
      <Typography component="h1" variant="h3">
            Video Audition
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
          Please submit a public viewable link to a video audition. 
          If the link is not viewable, we will email you ASAP and require that you send us an updated link. 
          If the link is not sent within our time frame, you will be subject to a fine for consideration of your application.
        </Typography>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
          *The Bhangra in the Burgh XVI Board acknowledges that COVID-19 continues to affect the ability to meet and practice. 
          If there are rules/regulations that are not possible for your team, please reach out to us by email and we will accommodate on a case to case basis.*
        </Typography>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
          This audition video can be no shorter than three minutes and no longer than five minutes of your team’s routine. 
          Your team’s video must be taped after April 1st, 2022. 
          Only videos including at least 50% of the submitted roster will be accepted. 
          Only one prop segment is permitted. 
          Tech-time rehearsal videos are permitted. 
          No costumes or lighting effects are permitted in the videos. 
          No apparel with logos or writing that shows affiliation to your team is permitted.
        </Typography>
        <Box pb={2}/>
        <form className={classes.form} onSubmit={handleSignUp}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="link"
            label="Link"
            name="link"
            value = {link}
            onChange = {onChangeFunction}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </div>
    </Container>
    </ThemeProvider>
  );
}